import { FormProvider, useForm } from 'react-hook-form';
import { PrevHeaderBarWithTitleTemplate } from '#templates';

import ScheduleSameTime from 'src/refactor_components/schedule-edit/schedule-same-time';
import { ScheduleDate } from 'src/refactor_components/schedule-edit/schedule-date';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import request from '#api/axios';
import { useEffect, useLayoutEffect } from 'react';
import { useToast } from '#providers/ToastProvider';
import { useNavigate } from 'react-router';

const ScheduleEdit = () => {
  const { showToast } = useToast();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const methods = useForm();

  const getCoachSchedules = async () => {
    const res = await request<any>({
      method: 'get',
      url: `/schedules/coach/profile`
    });
    return res.data;
  };

  const data = queryClient.getQueryData(['schedule']);
  const { data: fetchedData } = useQuery({
    queryKey: ['schedule'],
    queryFn: () => getCoachSchedules()
  });

  const postCoachSchedules = async (payload: any) => {
    const res = await request({
      method: 'post',
      url: `/schedules/coach/profile`,
      data: payload
    });
    return res.data;
  };
  const mutation = useMutation({
    mutationKey: ['schedule-submit'],
    mutationFn: postCoachSchedules,
    onSuccess: () => {
      showToast({
        message: '수업 일정을 등록하였습니다.'
      });
      navigate('/profile');
    },
    onError: () => {
      showToast({
        type: 'fail',
        message: '수업 일정 등록에 실패했습니다.'
      });
    }
  });

  useEffect(() => {
    if (data || fetchedData) {
      return methods.reset(data || fetchedData);
    }
  }, [data, fetchedData]);

  return (
    <FormProvider {...methods}>
      <PrevHeaderBarWithTitleTemplate title="수업 일정" defaultBackground>
        <form
          onSubmit={methods.handleSubmit(data => {
            mutation.mutate(data);
          })}
          className="flex flex-col items-start p-20 h-[100dvh] justify-between"
        >
          <div className="w-full flex flex-col items-start">
            <p className="text-[#8E899F] text-[14px]">
              수업이 있는 요일을 선택하고 수업 시간을 설정해 주세요
            </p>
            <ScheduleSameTime />
            <ScheduleDate />
          </div>

          <button className="w-full py-16 rounded-8 bg-[#9170F2] text-white text-center">
            저장
          </button>
        </form>
      </PrevHeaderBarWithTitleTemplate>
    </FormProvider>
  );
};

export default ScheduleEdit;
